import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

function Shell({ children, testId }) {
  return (
    <div className="min-h-screen grid place-items-center px-6">
      <div className="surface-raised p-10 max-w-md w-full text-center fade-up" data-testid={testId}>{children}</div>
    </div>
  );
}

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refreshUser } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) return setState("error");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refreshUser();
          return setState("paid");
        }
        if (["expired", "failed"].includes(data.payment_status)) return setState("error");
      } catch (err) {
        if (err?.response?.status === 404) return setState("error");
      }
      if (++tries >= 20) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, refreshUser]);

  if (state === "checking")
    return (
      <Shell testId="payment-checking">
        <Loader2 className="animate-spin mx-auto text-[#39FF14]" size={32} />
        <div className="heading text-2xl font-black mt-4">Verifica pagamento…</div>
      </Shell>
    );
  if (state === "paid")
    return (
      <Shell testId="payment-success">
        <CheckCircle2 className="mx-auto text-[#39FF14]" size={40} />
        <div className="heading text-3xl font-black mt-4">Benvenuto in Premium</div>
        <p className="text-sm text-[#A1A1AA] mt-2">Le analisi AI complete sono sbloccate su tutte le partite.</p>
        <Link to="/" className="mt-6 inline-block bg-[#39FF14] text-black font-black uppercase text-sm px-6 py-3 hover:bg-white transition-colors" data-testid="payment-success-continue">Vai alle partite</Link>
      </Shell>
    );
  return (
    <Shell testId="payment-error">
      <XCircle className="mx-auto text-[#FFCC00]" size={40} />
      <div className="heading text-2xl font-black mt-4">{state === "timeout" ? "Conferma in ritardo" : "Pagamento non completato"}</div>
      <p className="text-sm text-[#A1A1AA] mt-2">{state === "timeout" ? "Stiamo ancora aspettando la conferma da Stripe. Ricarica la pagina tra poco." : "Il pagamento non è andato a buon fine."}</p>
      <Link to="/premium" className="mt-6 inline-block border border-[#27272A] text-sm px-6 py-3 hover:border-white transition-colors">Torna a Premium</Link>
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell testId="payment-cancel">
      <XCircle className="mx-auto text-[#A1A1AA]" size={40} />
      <div className="heading text-2xl font-black mt-4">Pagamento annullato</div>
      <p className="text-sm text-[#A1A1AA] mt-2">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
      <Link to="/premium" className="mt-6 inline-block bg-[#39FF14] text-black font-black uppercase text-sm px-6 py-3 hover:bg-white transition-colors" data-testid="payment-cancel-retry">Torna a Premium</Link>
    </Shell>
  );
}
